import React from 'react';

const LoadingSpinner = ({ size = 24, color = '#2563eb' }) => {
    return (
        <div
            style={{
                width: size,
                height: size,
                border: '3px solid #e2e8f0',
                borderTop: `3px solid ${color}`,
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
            }}
        />
    );
};

export default LoadingSpinner;
